import { render, staticRenderFns } from "./VDateFilter.vue?vue&type=template&id=2f1a3f89"
import script from "./VDateFilter.vue?vue&type=script&lang=js"
export * from "./VDateFilter.vue?vue&type=script&lang=js"
import style0 from "./VDateFilter.vue?vue&type=style&index=0&id=2f1a3f89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports